export class MultiAccordion {
    constructor(container) {
        this.container = container;
    }

    init() {
        this.initBadgerAccordion();
    }

    initBadgerAccordion() {
        console.log('Accordion.initBadgerAccordion', this.container);
        this.accordion = new BadgerAccordion(this.container, {
            openHeadersOnLoad: [ 0 ],
            openMultiplePanels: true,
        });
        this.container.classList.add('fouc-ready');
    }
}
